import React from 'react';

import { Route, IndexRoute } from 'react-router';

import { AppContainer }             from './app/containers/App';
import { DashboardContainer }       from './dashboard/containers/DashboardPage';
import { LoginContainer }           from './auth/containers/Login';
import { Logout }                   from './auth/containers/Logout';
import { SettingsContainer }        from './settings/containers/Settings';
import { VisitContainer }           from './visits/containers/Visit';
import VisitOverviewContainer       from './visits/containers/VisitOverview';
import NotFound                     from './error/components/NotFound';
import UploadContainer              from './app/containers/Upload';
import redirectTo                   from 'app/lib/redirectTo';

import { accessLevels } from 'app/access';


export const createRoutes = (requireAccess) => {
    return (
        <Route path="/" component={AppContainer}>
            <IndexRoute component={redirectTo('/visits')} onEnter={requireAccess(accessLevels.user)} />
            <Route path="/login" component={LoginContainer} />
            <Route path="/logout" component={Logout} />
            <Route path="/dashboard" component={DashboardContainer} />
            <Route path="/settings(/:page)" component={SettingsContainer} onEnter={requireAccess(accessLevels.user)} />
            <Route path="/visits" component={VisitOverviewContainer} onEnter={requireAccess(accessLevels.user)} />
            <Route path="/visits/new" component={VisitContainer} onEnter={requireAccess(accessLevels.user)} />
            <Route path="/visits/:vtrac" component={VisitContainer} onEnter={requireAccess(accessLevels.user)} />
            <Route path="/upload" component={UploadContainer} />
            <Route path="*" component={NotFound} />
        </Route>
    );
};
